import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { adminSlice } from './admin';
import { authorizedEmailAdapter, authorizedEmailSlice } from './authorizedEmails';
import { viewCampagneSlice } from './campagne';
import { campagneAdapter, campagneSlice } from './campagnes';
import { contactSlice } from './contactSlice';
import { deviceSlice } from './deviceSlice';
import { editCampagneSlice } from './editCampagneSlice';
import { editFranchiseSlice } from './editFranchiseSlice';
import { editTerritorySlice } from './editTerritorySlice';
import { fileAdapter, fileSlice } from './files';
import { franchiseAdapter, franchiseSlice } from './franchises';
import { galleryCommentAdapter, galleryCommentSlice } from './galleryComments';
import { galleryImageAdapter, galleryImageSlice } from './galleryImages';
import { googleMapSlice } from './googleMapSlice';
import { gridErrorAdapter, gridErrorSlice } from './gridErrors';
import { messageSentSlice } from './messageSent';
import { parametreSlice } from './parametreSlice';
import { projectAdapter, projectSlice } from './projects';
import { recaptchaSlice } from './recaptchaSlice';
import { submissionAdapter, submissionSlice } from './submissions';
import { territoryAdapter, territorySlice } from './territories';
import { trackingAdapter, trackingSlice } from './trackings';
import { userAdapter, userSlice } from './users';
import { zoneAdapter, zoneSlice } from './zoneSlice';

let preloadedState: any = undefined;
try {
    preloadedState = (window as unknown as any).__PRELOADED_STATE__;
} catch (ReferenceError) {
    // do nothing
}

export const configureNewStore = () => configureStore({
    reducer: {
        contact: contactSlice.reducer,
        device: deviceSlice.reducer,
        franchises: franchiseSlice.reducer,
        campagnes: campagneSlice.reducer,
        galleryComments: galleryCommentSlice.reducer,
        galleryImages: galleryImageSlice.reducer,
        users: userSlice.reducer,
        authorizedEmails: authorizedEmailSlice.reducer,
        admin: adminSlice.reducer,
        recaptcha: recaptchaSlice.reducer,
        editFranchise: editFranchiseSlice.reducer,
        editCampagne: editCampagneSlice.reducer,
        submissions: submissionSlice.reducer,
        territories: territorySlice.reducer,
        editTerritory: editTerritorySlice.reducer,
        projects: projectSlice.reducer,
        parametres: parametreSlice.reducer,
        messageSent: messageSentSlice.reducer,
        files: fileSlice.reducer,
        gridErrors: gridErrorSlice.reducer,
        trackings: trackingSlice.reducer,
        viewCampagne: viewCampagneSlice.reducer,
        googleMap: googleMapSlice.reducer,
        zones: zoneSlice.reducer
    },
    preloadedState: preloadedState
});

export const appStore = configureNewStore();
export type AppState = ReturnType<typeof appStore.getState>;
setupListeners(appStore.dispatch);
export type AppDispatch = typeof appStore.dispatch;

export const franchiseSelector = franchiseAdapter.getSelectors((state: AppState) => state.franchises);
export const campagneSelector = campagneAdapter.getSelectors((state: AppState) => state.campagnes);
export const galleryCommentSelector = galleryCommentAdapter.getSelectors((state: AppState) => state.galleryComments);
export const galleryImageSelector = galleryImageAdapter.getSelectors((state: AppState) => state.galleryImages);
export const userSelector = userAdapter.getSelectors((state: AppState) => state.users);
export const authorizedEmailSelector = authorizedEmailAdapter.getSelectors((state: AppState) => state.authorizedEmails);
export const submissionSelector = submissionAdapter.getSelectors((state: AppState) => state.submissions);
export const territorySelector = territoryAdapter.getSelectors((state: AppState) => state.territories);
export const projectSelector = projectAdapter.getSelectors((state: AppState) => state.projects);
export const fileSelector = fileAdapter.getSelectors((state: AppState) => state.files);
export const gridErrorSelector = gridErrorAdapter.getSelectors((state: AppState) => state.gridErrors);
export const trackingSelector = trackingAdapter.getSelectors((state: AppState) => state.trackings);
export const zoneSelector = zoneAdapter.getSelectors((state: AppState) => state.zones);
